import axios from 'axios';
import auth from './auth';


export default{

    getAccessToken(jwt) {
        console.log(jwt);
        //call api to fetch a fresh access token
        //return "mynewfreshaccesstoken";
        let accessToken = "eyJraWQiOiJwd3FcL3FEa01SVHhDcXNwalYrWFZYUkJFRHpmZWh0UU1hdktFU0E4czNLVT0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI0MzMwNTIzOS0wZjJhLTQxYzAtYjY4OS0yMDg2NDkxZDA1ZTgiLCJldmVudF9pZCI6IjQ1ZGIzY2IyLWY3YmUtNDg1MC1iM2E5LWEyYzIwOGZhNzI1OSIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoib3BlbmlkIGVtYWlsIiwiYXV0aF90aW1lIjoxNjM2NjM5NDM2LCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuZXUtY2VudHJhbC0xLmFtYXpvbmF3cy5jb21cL2V1LWNlbnRyYWwtMV9lZjlnRkttTjYiLCJleHAiOjE2MzY2NDMwMzYsImlhdCI6MTYzNjYzOTQzNiwidmVyc2lvbiI6MiwianRpIjoiM2YwYTJkNzMtZTAxNS00ZjA2LTk4MGUtNzVjNDg5NmQ5ZmJjIiwiY2xpZW50X2lkIjoiMTVxdmk0bDYyODI2b3FmNzRvNXZuZmxuOG4iLCJ1c2VybmFtZSI6IjQzMzA1MjM5LTBmMmEtNDFjMC1iNjg5LTIwODY0OTFkMDVlOCJ9.B8p_7JHu5xZrmnw0piJFmYUBqlEk8D4a-bVR79Z7CyCfJEyeKr4u68P43fFvpblp784JKkyTh74U02ff5L4j_nuqia-moqAhnJKyYdlJZSXrdu4teGC1DTIBd4bUTtYYzsNOnEoww06_V1kGcwhMDBUj5oIqMcLtMJlkI9QbzVwfj7on-hsml80uF1MDpeIwwbFwUP_jW6SRPiHerNrDtpHPpCoNT0r8sfO-GxDzkWXtcAbaZVhuBWBaEmHlwaDW0Fgny8hLAmLm6WZ9EgJXf-dlueyZepyBdpL85zU-0qdAKyAKXBeIn7-Wy1jvWrQJAkwH9iiwbWpr7NA3AaLMuA";
        return "https://keg-myaccount.srm.no/#access_token=" + accessToken + "&token_type=bearer&expires_in=3600&state=STATE";
    },

    getUserInfo(){
       let accessToken = auth.auth.getSignInUserSession().getAccessToken().jwtToken;
        const USERINFO_URL = 'https://'+auth.auth.getAppWebDomain() + '/oauth2/userInfo';
        console.log(USERINFO_URL);
        let requestData = {
            headers: {
                'Authorization': 'Bearer '+ accessToken
            }
        }
        return axios.get(USERINFO_URL, requestData).then(response => {
            return response.data;
        });
    }
}